import { Link } from "react-router-dom";
import { useState } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
const initialFieldValues = {
    leadId: "00000000-0000-0000-0000-000000000000",
    firstName: "",
    lastName: "",
    businessName: "",
    email: "",
    phoneNumber: "",
    mandatory: false
};
export default function Lead(props) {
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(false);
    const [status, setStatus] = useState(false);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
        setValues({
            ...values,
            [name]: type === 'checkbox' ? checked : value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.firstName = values.firstName === "" ? false : true;
        temp.lastName = values.lastName === "" ? false : true;
        temp.businessName = values.businessName === "" ? false : true;
        temp.email = values.email === "" ? false : true;
        temp.phoneNumber = values.phoneNumber === "" ? false : true;
        temp.mandatory = values.mandatory === false ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(true);
            var formData = {
                "leadId": values.leadId,
                "firstName": values.firstName,
                "lastName": values.lastName,
                "businessName": values.businessName,
                "email": values.email,
                "phoneNumber": values.phoneNumber
            }
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATELEAD, newrecord, { ...headerconfig }),
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATELEAD, updateRecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        applicationAPI()
            .create(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Form successfully submitted");
                    resetForm();
                    setStatus("SUCCESS");
                    setBtnSubmit(false);
                }
                else {
                    handleError(res.data.data);
                    setStatus("ERROR");
                    setBtnSubmit(false);
                }
            })
            .catch(function (error) {
                setStatus("ERROR");
                setBtnSubmit(false);
            });
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    return (
        <div className="bg-white p-7 rounded-3">
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="d-flex flex-column gap-sm-7 gap-3">
                    <div className="d-flex flex-sm-row flex-column gap-sm-7 gap-3">
                        {status === "SUCCESS" ? <span className="badge bg-success w-100 p-3">Thanks for contacting us. Our team will get back to you soon.</span> : ""}
                    </div>
                    <div className="pb-2 border-bottom border-white border-opacity-10 position-relative z-1">
                        <p className="fs-4 mb-0 text-black">
                            Have questions or need assistance? We're just a message away.
                        </p>
                        <h3 className="text-black fs-6 fw-bolder mt-4">Reach Out Today</h3>
                        <div className="position-relative z-1">
                            <p className="fs-3 mb-0 text-black p-1">
                                Email : {props?.email}
                            </p>
                            <p className="fs-3 mb-0 text-black p-1">
                               Phone Number : {props?.phoneNumber}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 mb-2">
                            <label htmlFor="name" className="fs-3 fw-semibold">First Name *</label>
                            <input type="text" value={values.firstName} maxLength={45} name="firstName" onChange={handleInputChange} className={"form-control" + applyErrorClass('firstName')} placeholder="Please Enter First Name" />
                            {errors.firstName === false ? (<div className="validationerror">Please enter first name </div>) : ('')}
                        </div>
                        <div className="col-4 mb-2">
                            <label htmlFor="name" className="fs-3 fw-semibold">Last Name *</label>
                            <input type="text" value={values.lastName} maxLength={45} name="lastName" onChange={handleInputChange} className={"form-control" + applyErrorClass('lastName')} placeholder="Please Enter Last Name" />
                            {errors.lastName === false ? (<div className="validationerror">Please enter last name </div>) : ('')}
                        </div>
                        <div className="col-4 mb-2">
                            <label htmlFor="name" className="fs-3 fw-semibold">Email *</label>
                            <input type="text" value={values.email} maxLength={50} name="email" onChange={handleInputChange} className={"form-control" + applyErrorClass('email')} placeholder="Please Enter Email" />
                            {errors.email === false ? (<div className="validationerror">Please enter email </div>) : ('')}
                        </div>
                        <div className="col-4 mb-2">
                            <label htmlFor="phoneNumber" className="fs-3 fw-semibold">Phone Number *</label>
                            <input type="text" value={values.phoneNumber} name="phoneNumber" onChange={handleInputChange} className={"form-control" + applyErrorClass('phoneNumber')} placeholder="Please Enter Phone Number" />
                            {errors.phoneNumber === false ? (<div className="validationerror">Please enter phone Number </div>) : ('')}
                        </div>
                        <div className="col-4 mb-2">
                            <label htmlFor="businessName" className="fs-3 fw-semibold">Business Name *</label>
                            <input type="text" value={values.businessName} name="businessName" onChange={handleInputChange} className={"form-control" + applyErrorClass('businessName')} placeholder="Please Enter Business Name" />
                            {errors.businessName === false ? (<div className="validationerror">Please enter business name </div>) : ('')}
                        </div>
                        <div className="col-4 mb-2">
                            <button className="btn btn-success mt-4 w-100">Submit</button>
                        </div>
                    </div>
                    <div className="d-flex flex-sm-row flex-column gap-sm-7 gap-3">
                        <div className="d-flex flex-column flex-grow-1 gap-2">
                            <p>
                                <input type="checkbox" name="mandatory" checked={values.mandatory} onChange={handleInputChange} className="me-2"></input>
                                By checking this box, you agree to receive text messages (e.g., payment reminders) from BrokerSync 360 at the cell number used when signing up.  Consent is not a condition of any purchase. Reply STOP to unsubscribe, HELP for help. Message & data rates may apply. Message frequency varies. I have read and agree with the
                                <Link to={"/terms"} className="text-primary me-2" target="_blank">Terms & Conditions</Link> & <Link to={"/privacypolicy"} className="text-primary me-2" target="_blank">privacy Policy</Link>
                                {errors.mandatory === false ? (<div className="validationerror">Please accept terms & conditions </div>) : ('')}
                            </p>
                        </div>
                    </div>
                    <div className="d-flex flex-sm-row flex-column gap-sm-7 gap-3">
                        <div className="d-flex flex-column flex-grow-1 gap-2">
                            <label></label>
                            
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}